import { ChangeDetectorRef, Component, EventEmitter, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RelationshipTypesEnum, RelationshipTypesLabels, RelationshipTypesOpposites } from '@app/modules/relation-relation/enum/relationship-types.enum';
import { RelationRelationCreateModel } from '@app/modules/relation-relation/models/relation-relation-create.model';
import { ClaimTypes, ClaimValues } from '@app/shared/models/common/constants';
import { KeyValueModel } from '@app/shared/models/common/key-value.model';
import { isFormValid, processBackendValidatorsErrors } from '@app/shared/utilities/validation.utilities';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { filter, Observable } from 'rxjs';

@Component({
    selector: 'app-relation-relation-create-modal',
    templateUrl: './relation-relation-create-modal.component.html',
})
export class RelationRelationCreateModalComponent {
    errors: { [key: string]: string[] } = {};
    readonly nzModalData = inject(NZ_MODAL_DATA);

    relations$: Observable<KeyValueModel[]> = this.nzModalData.relations$;

    searchEmmiter: EventEmitter<{ searchQuery: string; skipCount: number }> = this.nzModalData.searchEmitter;
    create: EventEmitter<RelationRelationCreateModel> = this.nzModalData.createEmitter;
    relationName: string = this.nzModalData.relationName;
    relationId: number = this.nzModalData.relationId;

    errors$: Observable<{ [key: string]: string[] }> = this.nzModalData.errors$;

    relationshipTypes = RelationshipTypesEnum

    relationshipTypeLabels = RelationshipTypesLabels

    relationshipTypeOpposites = RelationshipTypesOpposites

    searchEmitterSearch(event: { searchQuery: string; skipCount: number }) {
        this.searchEmmiter.emit(event);
    }

    formGroup = new FormGroup({
        relatedRelationId: new FormControl<number | null>(null, Validators.required),
        relationshipType: new FormControl<RelationshipTypesEnum | null>(null, Validators.required),
        relatedRelationshipType: new FormControl<RelationshipTypesEnum | null>({value: null, disabled: true}),
    });


    constructor(private readonly modal: NzModalRef, private readonly changeDetectorRef: ChangeDetectorRef) {
        this.errors$
            .pipe(
                takeUntilDestroyed(),
                filter((x) => Object.keys(x).length > 0),
            )
            .subscribe((x) => {
                processBackendValidatorsErrors(x, this.formGroup);
                this.changeDetectorRef.detectChanges();
            });
    }

    ClaimTypes = ClaimTypes;
    ClaimValues = ClaimValues;

    destroyModal(): void {
        this.modal.destroy();
    }

    submit() {
        if (isFormValid(this.formGroup)) {
            this.submitCreate();
            this.modal.triggerOk();
        }
    }

    private submitCreate() {
        const chosenRelationshipType = this.formGroup.controls.relationshipType.value;
        this.create.emit({
            relationId: this.relationId,
            relatedRelationId: this.formGroup.controls.relatedRelationId.value,
            companyId: null,
            relationShipType: chosenRelationshipType
        });
    }
}
